import React, { forwardRef } from "react";
import {  DocsLink,DEVHUBLink } from "@src/constant/navLinks";
import cn from "classnames";
import Button from "@src/components/Button";
import headerBG from "./header-bg.svg";
import bgReactangleExtension1 from "./bgReactangleExtension1.svg";
import bgReactangleExtension2 from "./bgReactangleExtension2.svg";
import bgReactangleExtension3 from "./bgReactangleExtension3.svg";
import styles from "./index.module.scss";

export default forwardRef((props, headerRef) => {
  return (
    <div ref={headerRef} className={styles.header}>
      <div className={styles.container}>
        <div className={styles.headerBGWrapper}>
          <div className={styles.headerBG}></div>
          <div className={styles.bgRectangle1}>
            <img
              src={bgReactangleExtension1}
              className={styles.bgRectangleExtension1}
              alt=""
            />
          </div>
          <div className={styles.bgRectangle2}>
            <img
              src={bgReactangleExtension2}
              className={styles.bgRectangleExtension2}
              alt=""
            />
          </div>
          <div className={styles.bgRectangle3}>
            <img
              src={bgReactangleExtension3}
              className={styles.bgRectangleExtension3}
              alt=""
            />
          </div>
        </div>

        <div className={styles.contentWrapper}>
          <div className={cn("flex", styles.content)}>
            <h1 className={styles.title}>
            The Confidential Infra for Institutional Onchain Finance
            </h1>
            {/* <div className={styles.desc}>
              <a href="" target="_blank">Learn about</a>&nbsp; zkFHE
              (zero knowledge fully homomorphic encryption) and zkTLS (secure
              multi-party computation with transport layer security) for data
              verification and computation.
            </div> */}
          </div>
          <div className={cn("flex", styles.btnWrapper)}>
            <Button
              link="https://dapp.primuslabs.xyz/"
              className={cn(styles.btn, "pc-view")}
            >
              Launch App
            </Button>
            <Button link={`${DEVHUBLink}`} className={cn(styles.btn, "mobile-view")}>
              Start Building
            </Button>
            <Button link={DocsLink} className={styles.btn} type="secondary">
              Explore Docs
            </Button>
          </div>
          <div className={cn(styles.rectangle, styles.small)} />
          <div className={cn(styles.rectangle, styles.big)} />
        </div>
      </div>
    </div>
  );
});
